export const formatScore = (score: number | null, defaultValue?: string): string => {
  if (score === null || score === undefined) return defaultValue || '';
  return score === 10 ? '10' : score.toFixed(1).toString();
};

export const badgeCounter = (length: number, max: number = 0): string => {
  if (!length) return '0';
  if (!max) return length.toString();
  return length <= max ? length.toString() : `${max}+`;
};
